<template>
  <div class="app-container">
    <navigation title="购买详情"></navigation>
    <div class="content">
      <img :src="shopImg" alt="">
      <button class="downLoad" @click="downs">
        <svg-icon iconClass='down' className='down-icon'></svg-icon>
        到相册
      </button>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'culturalDetail',
  components: {navigation, version},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      shopImg: ''
    }
  },
  created () {
    window.scroll(0, 0)
    let params = {
      id: this.$route.query.id
    }
    request('get', '/nlc-web/api/cultural/info',params).then(res => {
      console.log('文创详情', res)
      this.shopImg = this.baseUrl+res.data.imgPath
    })
  },
  methods: {
    getDetail () {

    },
    downs() {
      let params = {
        id: this.$route.query.id
      }
      // 抖音码下载记录
      request('post', '/nlc-web/api/cultural/downloadImg',params).then(res => {
        console.log('抖音码下载记录', res)
      })
      let alink = document.createElement("a");
      alink.href = this.shopImg
      alink.download = "pic"; //图片名
      alink.click();
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  min-height: calc(100% - .92rem);
  padding-top:.92rem;
}
.content{
  width: 6.94rem;
  margin:.26rem .28rem .16rem .28rem;
  border-radius:8px;
  background:#fff;
}
.content img{
  width:100%;
  height:100%;
}
.downLoad{
  width: 6.23rem;
  height: .88rem;
  /*background: #008095;*/
  /*box-shadow:inset 0px 14px 36px -11px rgba(0, 128, 149, 0.5), 5px 5px 10px 0px rgba(125, 194, 209, 0.5);*/
  border-radius: 60px;
  border:none;
  color:#fff;
  font-size:.36rem;
  margin:0 0 .3rem .35rem;
}
</style>



// WEBPACK FOOTER //
// src/view/culturalDetail/index.vue